module.exports = __webpack_public_path__ + "144033893aec6a0a4b8b661e282eaaeb.jpg";